/**
 * AURALA: HEADER SCROLL BEHAVIOR
 * Handles header visibility based on scroll direction and position.
 * Translated from useScrollHeader hook.
 */

(function() {
  'use strict';

  const header = document.querySelector('#site-header, .site-header');
  if (!header) return;
  if (header.hasAttribute('data-aurala-header-managed')) return;

  let isVisible = true;
  let isAtTop = true;
  let lastScrollY = 0;
  let ticking = false;

  function updateState() {
    const currentScrollY = window.scrollY;
    const prevScrollY = lastScrollY;
    
    // Check if at top
    const atTop = currentScrollY < 50;
    
    // Determine visibility based on scroll direction
    let visible = true;
    if (currentScrollY > prevScrollY && currentScrollY > 100) {
      visible = false;
    } else if (currentScrollY < prevScrollY) {
      visible = true;
    }
    
    isAtTop = atTop;
    isVisible = visible;
    lastScrollY = currentScrollY;
    ticking = false;

    // Update header classes
    header.classList.toggle('header-at-top', atTop);
    header.classList.toggle('header-visible', visible);
    header.classList.toggle('header-hidden', !visible);
  }

  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(updateState);
      ticking = true;
    }
  }

  // Initial state — run immediately
  updateState();

  // Run again after first paint (fixes black-on-load issue)
  requestAnimationFrame(updateState);

  // Run again after full load (covers slow hero media/video)
  window.addEventListener('load', updateState);

  // Normal listeners
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', updateState);
})();
